import React, { useState } from 'react';
import { InboxPanel, ConversationPanel } from '@zillow/messaging-ui';
import { ErrorBoundaryConstellation } from 'constellationExtended/ErrorBoundary/ErrorBoundaryConstellation';
import { css } from '@/styled-system/css';

export const Inbox = () => {
  const [conversationId, setConversationId] = useState<string | undefined>();

  const handleOpenCollaborationModal = () => {
    // TODO: Implement collaboration modal
    console.log('Open collaboration modal');
  };

  const handleOpenInviteLinkModal = () => {
    // TODO: Implement invite link modal
    console.log('Open invite link modal');
  };

  return (
    <ErrorBoundaryConstellation>
      <div className={css({ display: 'flex', height: '680px', gap: 0 })}>
        {/* Inbox Panel - Conversations List */}
        <div
          className={css({
            width: '45%',
            height: '100%',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            border: '1px solid',
            borderColor: 'gray.300',
            overflowY: 'scroll',
          })}
        >
          <div
            className={css({
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
            })}
          >
            <InboxPanel
              currentConversationId={conversationId}
              handleCardSelected={(id: string) => setConversationId(id)}
              onOpenCollaborationModal={handleOpenCollaborationModal}
              onOpenInviteLinkModal={handleOpenInviteLinkModal}
              showElapsed={true}
              showInvite={false}
            />
          </div>
        </div>

        {/* Conversation Panel - Messages */}
        <div
          className={css({
            width: '55%',
            height: '100%',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            border: '1px solid',
            borderColor: 'gray.300',
          })}
        >
          <div
            className={css({
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
            })}
          >
            {conversationId ? (
              <ConversationPanel conversationId={conversationId} />
            ) : (
              <div
                className={css({
                  padding: '20px',
                  textAlign: 'center',
                  color: 'gray.600',
                })}
              >
                Select a conversation to view messages
              </div>
            )}
          </div>
        </div>
      </div>
    </ErrorBoundaryConstellation>
  );
};
